module.exports = __webpack_public_path__ + "static/popup-4467bd7c3cee165ef82e24cf13d0f2ef.png";